// @ts-nocheck
// PLANTS ADDITIONAL
// Clean database with regional names support
// This file is too large for TypeScript to type-check efficiently

import { PlantData } from './plants-master-database'

export const additionalData = [
  {
    id: 'basil-genovese',
    name: 'Basil - Genovese',
    scientificName: 'Ocimum basilicum',
    category: 'herb',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6.0,
    phMax: 7.5,
    companions: ['tomato', 'pepper', 'oregano'],
    enemies: ['rue', 'sage'],
    description: 'Classic Italian basil for pesto. Large, aromatic leaves.',
    hardinessZones: '4-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Lamiaceae',
    varieties: ['Genovese', 'Italian Large Leaf'],
    uses: ['pesto', 'italian', 'aromatic', 'fresh']
  },
  {
    id: 'basil-thai',
    name: 'Basil - Thai',
    scientificName: 'Ocimum basilicum var. thyrsiflora',
    category: 'herb',
    spacing: 10,
    rowSpacing: 14,
    daysToGermination: 7,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6.0,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: ['rue'],
    description: 'Licorice-anise flavor. Purple stems and flowers. Essential for Thai cuisine.',
    hardinessZones: '4-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-16 inches',
    family: 'Lamiaceae',
    varieties: ['Siam Queen', 'Thai Basil'],
    uses: ['thai', 'asian', 'licorice', 'anise']
  },
  {
    id: 'basil-lettuce-leaf',
    name: 'Basil - Lettuce Leaf',
    scientificName: 'Ocimum basilicum',
    category: 'herb',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6.0,
    phMax: 7.5,
    companions: ['tomato', 'pepper'],
    enemies: ['rue'],
    description: 'Huge crinkled leaves, up to 5 inches long. Great for wraps.',
    hardinessZones: '4-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Lamiaceae',
    varieties: ['Napoletano', 'Lettuce Leaf'],
    uses: ['wraps', 'large leaves', 'sandwiches']
  },
  {
    id: 'basil-cinnamon',
    name: 'Basil - Cinnamon',
    scientificName: 'Ocimum basilicum',
    category: 'herb',
    spacing: 10,
    rowSpacing: 14,
    daysToGermination: 7,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6.0,
    phMax: 7.5,
    companions: ['tomato'],
    enemies: ['rue'],
    description: 'Spicy cinnamon scent and flavor. Purple flowers.',
    hardinessZones: '4-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-16 inches',
    family: 'Lamiaceae',
    varieties: ['Cinnamon Basil'],
    uses: ['cinnamon', 'spicy', 'unique', 'tea']
  }
] as PlantData[]
